import { ArrowDropDownRounded } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSelector } from "react-redux";

type SelectOptionsProps = {
  value: string;
  options?: { label: string; value: string }[] | string[];
  handleChange: (value: string) => void;
  label?: string;
};
const SelectOptions = ({ value, options, label, handleChange }: SelectOptionsProps) => {
  const isDarkMode = useSelector((state: { theme }) => state.theme.darkMode);

  return (
    <Select
      id="demo-select-small"
      value={value}
      label={label}
      className="!rounded-full w-full max-h-[42px] select-no-outline bg-tgpt-secondary-accentLight text-mui-black-60 dark:text-white"
      onChange={e => handleChange(e.target.value)}
      IconComponent={() => (
        <ArrowDropDownRounded className="text-action-active me-2" />
      )}
      MenuProps={{
        PaperProps: {
          className: "custom-scrollbar",
          style: {
            backgroundColor: isDarkMode ? "#2E2E2E" : "white",
            maxHeight: "250px",
            overflowY: "auto",
            borderRadius: "8px",
            boxShadow: "0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.20);",
          },
        },
      }}
    >
      {options?.map((option) => {
        return typeof option === "string" || typeof option === "number"
          ? (
              <MenuItem key={option} value={option} className="dark:!text-white !text-mui-black-87">
                {option}
              </MenuItem>
            )
          : (
              <MenuItem key={option.value} value={option.value} className="dark:!text-white !text-mui-black-87">
                {option.label}
              </MenuItem>
            );
      })}
    </Select>
  );
};

export default SelectOptions;
